import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../redux/slices/userSlice';
import { logoutUser } from '../redux/slices/authSlice';

const AdminSidebar = ({ setActiveSection, activeSection }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { admin } = useSelector((state) => state.auth);

    // Uncomment to fetch admin profile on mount
    // useEffect(() => {
    //   dispatch(getCurrentUser());
    // }, [dispatch]);

    const handleLogout = () => {
        const confirmLogout = window.confirm('Are you sure you want to logout?');
        if (confirmLogout) {
            dispatch(logoutUser());
            navigate('/admin-login');
        }
    };

    const profileImg = admin?.photo || '/avatar.png';
    const name = admin?.name || 'Admin Panel';
    const email = admin?.email || 'admin@travelco.com';

    return (
        <div className="fixed top-0 left-0 h-full w-72 bg-custom-white shadow-lg rounded-r-xl z-20 flex flex-col justify-between">
            <div className="p-4">
                <div className="flex flex-col items-center mb-8">
                    {/* <img
                        src={profileImg}
                        alt="Admin Profile"
                        className="w-40 h-40 rounded-full mb-3 object-cover"
                    /> */}
                    <div className="text-center">
                        <h2 className="text-2xl font-bold text-custom-blue">{name}</h2>
                        <p className="text-sm text-gray-500 mt-1">{email}</p>
                    </div>
                </div>

                <ul className="space-y-2">
                    <li>
                        <button
                            onClick={() => navigate('/admin-dashboard')}
                            className={`flex items-center p-3 w-full text-left text-lg font-medium rounded-md transition-colors ${window.location.pathname === '/admin-dashboard'
                                ? 'bg-custom-yellow text-custom-blue border-l-4 border-custom-blue'
                                : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-3">📦</span> Create Package
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => navigate('/all-package')}
                            className={`flex items-center p-3 w-full text-left text-lg font-medium rounded-md transition-colors ${window.location.pathname === '/all-package'
                                ? 'bg-custom-yellow text-custom-blue border-l-4 border-custom-blue'
                                : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-3">📋</span> All Packages
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => navigate('/all-banner')}
                            className={`flex items-center p-3 w-full text-left text-lg font-medium rounded-md transition-colors ${activeSection === 'all-banner'
                                ? 'bg-custom-yellow text-custom-blue border-l-4 border-custom-blue'
                                : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-3">🖼️</span> All Banners
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => navigate('/create-reviews')}
                            className={`flex items-center p-3 w-full text-left text-lg font-medium rounded-md transition-colors ${activeSection === 'all-banner'
                                ? 'bg-custom-yellow text-custom-blue border-l-4 border-custom-blue'
                                : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-3">🗣️</span> Add Reviews
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => navigate('/all-user')}
                            className={`flex items-center p-3 w-full text-left text-lg font-medium rounded-md transition-colors ${activeSection === 'all-user'
                                ? 'bg-custom-yellow text-custom-blue border-l-4 border-custom-blue'
                                : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-3">👥</span> All Users
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => navigate('/review-management')}
                            className={`flex items-center p-3 w-full text-left text-lg font-medium rounded-md transition-colors ${window.location.pathname === '/review-management'
                                ? 'bg-custom-yellow text-custom-blue border-l-4 border-custom-blue'
                                : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-3">⭐</span> Reviews
                        </button>
                    </li>

                    <li>
                        <button
                            onClick={() => navigate('/contact-management')}
                            className={`flex items-center p-3 w-full text-left text-lg font-medium rounded-md transition-colors ${window.location.pathname === '/contact-management'
                                ? 'bg-custom-yellow text-custom-blue border-l-4 border-custom-blue'
                                : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-3">☎️</span> Contact Management
                        </button>
                        <div className="p-6">
                            <button
                                onClick={handleLogout}
                                className="w-full bg-red-600 text-custom-white py-2.5 rounded-lg font-medium hover:bg-red-700 transition-colors flex items-center justify-center"
                            >
                                <span className="mr-2">🚪</span> Logout
                            </button>
                        </div>
                    </li>
                </ul>
            </div>

            {/* Logout Button */}

        </div>
    );
};

export default AdminSidebar;